module.exports = __webpack_public_path__ + "static/assets/e6b451dc51ec57a5fdccda8bf71c433e.svg";